import { EventEmitter } from '@angular/core';
import { TemplateService } from '../../../../../services/template.service';
import { CALENDAR_LOCALE } from '../../../../../services/constant';
import { FormBuilder, Validators } from '@angular/forms';
import { combineLatest, concat, of, Subject } from 'rxjs';
import { ApiService } from '../../../../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import * as moment from 'moment';
var DocumentFormComponent = (function () {
    function DocumentFormComponent(apiService, formBuilder, template, translateService) {
        this.apiService = apiService;
        this.formBuilder = formBuilder;
        this.template = template;
        this.translateService = translateService;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.refreshingDocumentNumber = false;
        this.documentRequestSelected = new EventEmitter;
        this.documentRequestInput$ = new Subject();
        this.searchingDocumentRequest = false;
        this.abbNoChecked = false;
        this.confirmationNoChecked = false;
        this.enabledCustomerRequest = environment.enabledCustomerRequest;
        this.today = new Date();
        this.calendarLocale = CALENDAR_LOCALE.EN;
    }
    DocumentFormComponent.prototype.ngDoCheck = function () {
        this.changeCalendarLocale();
    };
    DocumentFormComponent.prototype.ngOnInit = function () {
        this.changeCalendarLocale();
        this.setDocumentTypes();
        this.createDocumentForm();
        this.loadDocumentRequest();
        // any time the inner form changes update the parent of any change
        this.createSubscriptions();
    };
    Object.defineProperty(DocumentFormComponent.prototype, "currentLang", {
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.loadDocumentRequest = function () {
        var _this = this;
        this.documentRequests$ = concat(of([]), this.documentRequestInput$.pipe(filter(function (term) { return term != null && term.length >= 2; }), distinctUntilChanged(), debounceTime(300), tap(function () { return _this.searchingDocumentRequest = true; }), switchMap(function (term) {
            return _this.apiService.getDocumentRequestDropdown({ request_no: term }).pipe(catchError(function () { return of([]); }), tap(function () { return _this.searchingDocumentRequest = false; }));
        })));
    };
    DocumentFormComponent.prototype.onChangeDocumentRequest = function (event) {
        if (event && event.abb_no) {
            this.abbNoChecked = true;
            this.abbNo.enable();
        }
        else {
            this.abbNoChecked = false;
            this.abbNo.disable();
        }
        if (event && event.confirmation_no) {
            this.confirmationNoChecked = true;
            this.confirmationNo.enable();
        }
        else {
            this.confirmationNoChecked = false;
            this.confirmationNo.disable();
        }
        this.documentForm.patchValue({
            abbNo: event ? event.abb_no : '',
            confirmationNo: event ? event.confirmation_no : '',
        });
        this.documentRequestSelected.emit(event);
    };
    DocumentFormComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    DocumentFormComponent.prototype.writeValue = function (value) {
        if (value) {
            this.documentForm.setValue(value);
            this.onChange(value);
            this.onTouched();
        }
    };
    DocumentFormComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DocumentFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // communicate the inner form validation to the parent form
    DocumentFormComponent.prototype.validate = function (_control) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.documentForm.valid ? resolve(null) : resolve({ documentForm: { valid: false } });
        });
    };
    DocumentFormComponent.prototype.createSubscriptions = function () {
        var _this = this;
        // Subscribe to valueChanges and statusChanges
        this.subscription = combineLatest([this.documentForm.valueChanges, this.documentForm.statusChanges]).subscribe(function () {
            _this.onChange(_this.documentForm.getRawValue());
            _this.onTouched();
        });
    };
    DocumentFormComponent.prototype.setDocumentTypes = function () {
        var _this = this;
        this.documentTypes = this.template.getDropdown();
        if (this.isCreditNote || this.isDebitNote) {
            this.documentTypes.shift();
        }
        else {
            this.documentTypes = this.documentTypes.filter(function (element) { return element.value === _this.documentType; });
        }
    };
    DocumentFormComponent.prototype.changeCalendarLocale = function () {
        this.lang = localStorage.getItem('lang');
        this.calendarLocale = this.lang && this.lang === 'th' ? CALENDAR_LOCALE.TH : CALENDAR_LOCALE.EN;
    };
    Object.defineProperty(DocumentFormComponent.prototype, "isCreditNote", {
        get: function () {
            return this.documentType === 'credit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "isDebitNote", {
        get: function () {
            return this.documentType === 'debit_note';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "isDeliveryOrder", {
        get: function () {
            return this.documentType === 'delivery_order_tax_invoice';
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.createDocumentForm = function () {
        var documentType = this.documentTypes.length === 1 ? this.documentTypes[0].value : null;
        var required = (this.isCreditNote || this.isDebitNote) ? Validators.required : null;
        this.documentForm = this.formBuilder.group({
            documentNo: [null, Validators.required],
            documentDate: [this.today, Validators.required],
            abbNo: [{ value: null, disabled: true }],
            confirmationNo: [{ value: null, disabled: true }],
            documentRequest: [],
            orderNo: [{ value: null, disabled: true }],
            runningNo: [{ value: null, disabled: true }],
            purpose: [null, required],
            referenceDocuments: this.formBuilder.array([
                this.formBuilder.group({
                    documentNo: [null, required],
                    documentType: [documentType, required],
                    documentDate: [null, required]
                })
            ])
        });
        this.setDocumentNumber(this.today);
    };
    DocumentFormComponent.prototype.setDocumentNumber = function (date) {
        var _this = this;
        this.refreshingDocumentNumber = true;
        this.apiService.getNextRunningNumber({ document_type: this.documentType, issue_date: moment(date).format('YYYY-MM-DD') }).subscribe(function (response) {
            _this.refreshingDocumentNumber = false;
            if (response.running_number) {
                _this.documentForm.controls.documentNo.setValue(response.running_number);
                _this.documentForm.controls.documentNo.updateValueAndValidity();
            }
        }, function () {
            _this.refreshingDocumentNumber = false;
        });
    };
    DocumentFormComponent.prototype.refreshDocumentNumber = function () {
        var date = this.documentForm.get('documentDate').value || this.today;
        this.setDocumentNumber(date);
    };
    Object.defineProperty(DocumentFormComponent.prototype, "documentNo", {
        get: function () {
            return this.documentForm.get('documentNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "documentDate", {
        get: function () {
            return this.documentForm.get('documentDate');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "abbNo", {
        get: function () {
            return this.documentForm.get('abbNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "confirmationNo", {
        get: function () {
            return this.documentForm.get('confirmationNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "orderNo", {
        get: function () {
            return this.documentForm.get('orderNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "runningNo", {
        get: function () {
            return this.documentForm.get('runningNo');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "purpose", {
        get: function () {
            return this.documentForm.get('purpose');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentFormComponent.prototype, "referenceDocuments", {
        get: function () {
            return this.documentForm.get('referenceDocuments');
        },
        enumerable: true,
        configurable: true
    });
    DocumentFormComponent.prototype.getReferenceDocumentNo = function (index) {
        return this.referenceDocuments.controls[index].get('documentNo');
    };
    DocumentFormComponent.prototype.getReferenceDocumentType = function (index) {
        return this.referenceDocuments.controls[index].get('documentType');
    };
    DocumentFormComponent.prototype.getReferenceDocumentDate = function (index) {
        return this.referenceDocuments.controls[index].get('documentDate');
    };
    DocumentFormComponent.prototype.addReferenceDocument = function () {
        this.referenceDocuments.push(this.formBuilder.group({
            documentNo: [null, Validators.required],
            documentType: [null, Validators.required],
            documentDate: [null, Validators.required]
        }));
    };
    DocumentFormComponent.prototype.removeReferenceDocument = function (index) {
        this.referenceDocuments.removeAt(index);
    };
    return DocumentFormComponent;
}());
export { DocumentFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-form/document-form.component.ts.pre-build-optimizer.js